<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.463 41.999">
  <path
    fill="#414c7fcc"
    d="M13.611 17.496c.475 2.326-.182 4.236-2.921 4.638-2.741.403-6.7 3.898-8.848-1.798-1.245-3.299-1.997-10.103-.461-10.328 1.537-.226 11.756 5.162 12.23 7.488Z"
  />
  <path
    fill="#aaaaffcc"
    d="M11.537 17.85c.865 1.392-2.205 3.833-3.844 4.568-1.639.736-2.915-.66-4.173-4.1-.55-1.503-1.234-5.532-.634-5.802.599-.268 7.785 3.942 8.651 5.334Z"
    data-player="true"
  />
  <path
    fill="#414c7fcc"
    d="M20.125 17.496c-.458 2.326.176 4.236 2.818 4.638 2.644.403 6.464 3.898 8.536-1.798 1.201-3.3 1.927-10.103.445-10.329-1.483-.225-11.342 5.163-11.799 7.489Z"
  />
  <path
    fill="#aaaaffcc"
    d="M22.126 17.85c-.835 1.392 2.127 3.833 3.708 4.568 1.581.736 2.812-.66 4.026-4.1.531-1.503 1.19-5.532.611-5.802-.577-.268-7.509 3.942-8.345 5.334Z"
    data-player="true"
  />
  <path
    fill="#414c7fcc"
    d="M31.1 34.911c0-.454-.188-1.091-.407-1.687.585.028 1.519.191 2.77.817a4.003 4.003 0 0 0-.273-1.393c.041.02.075.034.116.055-1.104-3.31-3.309-5.517-3.309-5.517h2.206c-2.331-4.663-4.965-8.015-8.075-9.559-1.39-.873-3.688-1.338-7.373-1.339h-.003c-3.696 0-5.996.468-7.385 1.346-3.104 1.547-5.734 4.896-8.061 9.552h2.207S1.306 29.392.202 32.703l.084-.039a2.685 2.685 0 0 0-.282 1.377c1.263-.632 2.217-.792 2.813-.818-.189.513-.343 1.044-.386 1.475a3.146 3.146 0 0 0-.135 1.343c3.207-1.458 4.707-1.25 6.457-.375 1.213 3.623 4.206 6.333 8.001 6.333 3.793 0 6.746-2.794 7.958-6.416 1.458-1.25 3.708-.875 6.416.416a2.844 2.844 0 0 0-.036-1.093l.008.005Z"
  />
  <path
    fill="#878eddcc"
    d="M33.306 32.703c-.437-1.313-3.665-3.101-6.973-4.513.26-.664.42-1.401.42-2.191 0-2.761-1.791-5-4-5s-4 2.239-4 5c0 3 4 10-2.001 11.118-5.125-.955-2.954-6.201-2.212-9.58.072-.276.125-.559.158-.853.034-.245.055-.476.055-.685 0-2.761-1.791-5-4-5s-4 2.239-4 5c0 .79.16 1.527.421 2.191-3.308 1.412-6.535 3.2-6.973 4.513 2.207-1.104 3.311-1.104 3.311-1.104s-1.104 2.208-1.104 3.312c2.67-1.78 5.339-2.122 7.429-.452 1.213 3.623 2.916 6.54 6.917 3.664 3.999 2.876 5.7-.04 6.912-3.662 2.092-1.673 4.763-1.33 7.434.45 0-1.104-1.103-3.312-1.103-3.312s1.103.001 3.309 1.104Z"
  />
  <path
    fill="#181c33cc"
    d="M9.753 24.999s0-1.5 1.5-1.5 1.5 1.5 1.5 1.5v1.5s0 1.5-1.5 1.5-1.5-1.5-1.5-1.5v-1.5Zm11 0s0-1.5 1.5-1.5 1.5 1.5 1.5 1.5v1.5s0 1.5-1.5 1.5-1.5-1.5-1.5-1.5v-1.5Zm-7.061 9.156c-1.021.208 2.041 3.968 3.062 3.968 1.02 0 4.082-3.76 3.062-3.968-1.02-.208-5.103-.208-6.124 0Z"
  />
  <path
    fill="#54617f44"
    d="M23.611 12.496c.475 2.326-.182 4.236-2.921 4.638-2.741.403-6.7 3.898-8.848-1.798-1.245-3.299-1.997-10.103-.461-10.328 1.537-.226 11.756 5.162 12.23 7.488Z"
  />
  <path
    fill="#d5d5ff44"
    d="M21.537 12.85c.865 1.392-2.205 3.833-3.844 4.568-1.639.736-2.915-.66-4.173-4.1-.55-1.503-1.234-5.532-.634-5.802.599-.268 7.785 3.942 8.651 5.334Z"
    data-player="true"
  />
  <path
    fill="#54617f44"
    d="M30.125 12.496c-.458 2.326.176 4.236 2.818 4.638 2.644.403 6.464 3.898 8.536-1.798 1.201-3.3 1.927-10.103.445-10.329-1.483-.225-11.342 5.163-11.799 7.489Z"
  />
  <path
    fill="#d5d5ff44"
    d="M32.126 12.85c-.835 1.392 2.127 3.833 3.708 4.568 1.581.736 2.812-.66 4.026-4.1.531-1.503 1.19-5.532.611-5.802-.577-.268-7.509 3.942-8.345 5.334Z"
    data-player="true"
  />
  <path
    fill="#54617f44"
    d="M41.1 29.911c0-.454-.188-1.091-.407-1.687.585.028 1.519.191 2.77.817a4.003 4.003 0 0 0-.273-1.393c.041.02.075.034.116.055-1.104-3.31-3.309-5.517-3.309-5.517h2.206c-2.331-4.663-4.965-8.015-8.075-9.559-1.39-.873-3.688-1.338-7.373-1.339h-.003c-3.696 0-5.996.468-7.385 1.346-3.104 1.547-5.734 4.896-8.061 9.552h2.207s-2.207 2.206-3.311 5.517l.084-.039a2.685 2.685 0 0 0-.282 1.377c1.263-.632 2.217-.792 2.813-.818-.189.513-.343 1.044-.386 1.475a3.146 3.146 0 0 0-.135 1.343c3.207-1.458 4.707-1.25 6.457-.375 1.213 3.623 4.206 6.333 8.001 6.333 3.793 0 6.746-2.794 7.958-6.416 1.458-1.25 3.708-.875 6.416.416a2.844 2.844 0 0 0-.036-1.093l.008.005Z"
  />
  <path
    fill="#aab2dd44"
    d="M43.306 27.703c-.437-1.313-3.665-3.101-6.973-4.513.26-.664.42-1.401.42-2.191 0-2.761-1.791-5-4-5s-4 2.239-4 5c0 3 4 10-2.001 11.118-5.125-.955-2.954-6.201-2.212-9.58.072-.276.125-.559.158-.853.034-.245.055-.476.055-.685 0-2.761-1.791-5-4-5s-4 2.239-4 5c0 .79.16 1.527.421 2.191-3.308 1.412-6.535 3.2-6.973 4.513 2.207-1.104 3.311-1.104 3.311-1.104s-1.104 2.208-1.104 3.312c2.67-1.78 5.339-2.122 7.429-.452 1.213 3.623 2.916 6.54 6.917 3.664 3.999 2.876 5.7-.04 6.912-3.662 2.092-1.673 4.763-1.33 7.434.45 0-1.104-1.103-3.312-1.103-3.312s1.103.001 3.309 1.104Z"
  />
  <path
    fill="#20253344"
    d="M19.753 19.999s0-1.5 1.5-1.5 1.5 1.5 1.5 1.5v1.5s0 1.5-1.5 1.5-1.5-1.5-1.5-1.5v-1.5Zm11 0s0-1.5 1.5-1.5 1.5 1.5 1.5 1.5v1.5s0 1.5-1.5 1.5-1.5-1.5-1.5-1.5v-1.5Zm-7.061 9.156c-1.021.208 2.041 3.968 3.062 3.968 1.02 0 4.082-3.76 3.062-3.968-1.02-.208-5.103-.208-6.124 0Z"
  />
  <path
    fill="#66757F"
    d="M33.611 7.496c.475 2.326-.182 4.236-2.921 4.638-2.741.403-6.7 3.898-8.848-1.798C20.597 7.037 19.845.233 21.381.008c1.537-.226 11.756 5.162 12.23 7.488Z"
  />
  <path
    fill="#808080"
    d="M31.537 7.85c.865 1.392-2.205 3.833-3.844 4.568-1.639.736-2.915-.66-4.173-4.1-.55-1.503-1.234-5.532-.634-5.802.599-.268 7.785 3.942 8.651 5.334Z"
    data-player="true"
  />
  <path
    fill="#66757F"
    d="M40.125 7.496c-.458 2.326.176 4.236 2.818 4.638 2.644.403 6.464 3.898 8.536-1.798 1.201-3.3 1.927-10.103.445-10.329-1.483-.225-11.342 5.163-11.799 7.489Z"
  />
  <path
    fill="#808080"
    d="M42.126 7.85c-.835 1.392 2.127 3.833 3.708 4.568 1.581.736 2.812-.66 4.026-4.1.531-1.503 1.19-5.532.611-5.802-.577-.268-7.509 3.942-8.345 5.334Z"
    data-player="true"
  />
  <path
    fill="#66757F"
    d="M51.1 24.911c0-.454-.188-1.091-.407-1.687.585.028 1.519.191 2.77.817a4.003 4.003 0 0 0-.273-1.393c.041.02.075.034.116.055-1.104-3.31-3.309-5.517-3.309-5.517h2.206c-2.331-4.663-4.965-8.015-8.075-9.559-1.39-.873-3.688-1.338-7.373-1.339h-.003c-3.696 0-5.996.468-7.385 1.346-3.104 1.547-5.734 4.896-8.061 9.552h2.207s-2.207 2.206-3.311 5.517l.084-.039a2.685 2.685 0 0 0-.282 1.377c1.263-.632 2.217-.792 2.813-.818-.189.513-.343 1.044-.386 1.475a3.146 3.146 0 0 0-.135 1.343c3.207-1.458 4.707-1.25 6.457-.375 1.213 3.623 4.206 6.333 8.001 6.333 3.793 0 6.746-2.794 7.958-6.416 1.458-1.25 3.708-.875 6.416.416a2.844 2.844 0 0 0-.036-1.093l.008.005Z"
  />
  <path
    fill="#CCD6DD"
    d="M53.306 22.703c-.437-1.313-3.665-3.101-6.973-4.513.26-.664.42-1.401.42-2.191 0-2.761-1.791-5-4-5s-4 2.239-4 5c0 3 4 10-2.001 11.118-5.125-.955-2.954-6.201-2.212-9.58.072-.276.125-.559.158-.853.034-.245.055-.476.055-.685 0-2.761-1.791-5-4-5s-4 2.239-4 5c0 .79.16 1.527.421 2.191-3.308 1.412-6.535 3.2-6.973 4.513 2.207-1.104 3.311-1.104 3.311-1.104s-1.104 2.208-1.104 3.312c2.67-1.78 5.339-2.122 7.429-.452 1.213 3.623 2.916 6.54 6.917 3.664 3.999 2.876 5.7-.04 6.912-3.662 2.092-1.673 4.763-1.33 7.434.45 0-1.104-1.103-3.312-1.103-3.312s1.103.001 3.309 1.104Z"
  />
  <path
    fill="#292F33"
    d="M29.753 14.999s0-1.5 1.5-1.5 1.5 1.5 1.5 1.5v1.5s0 1.5-1.5 1.5-1.5-1.5-1.5-1.5v-1.5Zm11 0s0-1.5 1.5-1.5 1.5 1.5 1.5 1.5v1.5s0 1.5-1.5 1.5-1.5-1.5-1.5-1.5v-1.5Zm-7.061 9.156c-1.021.208 2.041 3.968 3.062 3.968 1.02 0 4.082-3.76 3.062-3.968-1.02-.208-5.103-.208-6.124 0Z"
  />
</svg>
